import type { SfmCreateProps } from 'src/AppScopes'
import { SfmCreate } from 'src/AppScopes'
import { RoleEnum } from 'src/UserIdentity'

import { DocumentForm } from './Form'

export function DocumentCreate(props: SfmCreateProps) {
  return (
    <SfmCreate {...props} acceptedRoles={[RoleEnum.ROLE_CONFIGURATOR]}>
      <DocumentForm />
    </SfmCreate>
  )
}
